import { OptionButton } from "@/react/components/OptionButton";
import { useAccount, useSocialProviders } from "../hooks";
import { minifyAddress } from "based-shared/utils/minify-address";
import { useSimpleKitContext } from "@/react/context/SimpleKitContext";
import { routes } from "@/react/context/SimpleKitContext";
import { OptionSkeleton } from "@/react/components/OptionSkeleton";

export function SwitchAccount() {
  const { address, network, users } = useAccount();
  const { isPending } = useSocialProviders();
  const { setPendingItem, setRouter } = useSimpleKitContext();

  if (isPending) {
    return (
      <div className="web3kit-space-y-2">
        {Array.from({ length: 3 }).map((_, index) => (
          <OptionSkeleton key={index} index={index} className="web3kit-h-12" />
        ))}
      </div>
    );
  }

  return (
    <div className="web3kit-space-y-2">
      {users
        .filter(
          (user) => !(user.address === address && user.network === network)
        )
        .map((user, index) => (
          <OptionButton
            key={index}
            index={index}
            logo={user.image}
            onClick={() => {
              setPendingItem(() => {
                setRouter(routes.switchingAccount);
                return {
                  name: user.name,
                  logo: user.image,
                  args: [
                    {
                      network: user.network,
                      address: user.address,
                    },
                  ],
                  description: `We change your account to "${user.name}".`,
                };
              });
            }}
          >
            {minifyAddress(user.address)}
          </OptionButton>
        ))}
    </div>
  );
}
